import { useMutation } from "@tanstack/react-query";
import { fetchWithCsrf } from "@/lib/api";
import type { ApiSuccess, ApiError } from "@/types/api";

interface ApproveDeviceCodeResponse {
  deviceName: string | null;
}

export function useApproveDeviceCode() {
  return useMutation<ApiSuccess<ApproveDeviceCodeResponse>, ApiError, string>({
    mutationFn: async (code) => {
      return fetchWithCsrf("/api/device_codes/approve", {
        method: "POST",
        body: JSON.stringify({ code }),
      });
    },
  });
}
